import { NavLink } from "react-router-dom";

import React from "react";

function Navigation() {
  const navLinkRefs = React.useRef([]);

  const navLinks = [];

  const handler = idx => event => {
    const next = navLinkRefs.current[idx + 1];
  };

  for (let i = 1; i < 99; i++) {
    navLinks.push(<NavLink key={i} onClick={handler(i)} ref={(c) => (navLinkRefs.current[i] = c)} to={`/page${i}`}>{i}</NavLink>);
  }

  return (
    <div className="Navigation">
      <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>ii</NavLink>
      {navLinks}
    </div>
  );
}

export default Navigation;
